import '../Title/title.css';

const Title = (props) => {
  const { children, level = 1, size, style, color, component } = props;
  const classNameTitle = `title_${size} title_${color} title_${component}`;
  const Tag = `h${level}`;
  return (
    <Tag className={classNameTitle} style={style}>
      {children}
    </Tag>
  );
};
export default Title;
